import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { FormHelperText } from "@mui/material";
import Link from "@mui/material/Link";
import makeStyles from "@mui/styles/makeStyles";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
import Button from "@mui/material/Button";
import LoadingButton from "../../../components/LoadingButton";
import BoxActions from "./BoxActions";
import { useAuth } from "../../providers/AuthProvider";
import FormikTextField from "../../../components/Common/FormikTextField";
import Level2BoxContainer from "./Level2BoxContainer";
import Level2BoxHeading from "./Level2BoxHeading";
import ForgotPasswordDialog from "../../Mobile/Components/ForgotPasswordDialog";

const useStyles = makeStyles((theme) => ({
  form: {
    flexGrow: 1,
  },
  button: {
    flexBasis: "100px",
    flexShrink: 0,
    paddingLeft: 0,
    paddingRight: 0,
    flexGrow: 1,
  },
}));

const LoginExistingUser = ({ handleGoBack, handleLoginSuccess }) => {
  const { t } = useTranslation();
  const { isAuthenticating, loginError, login: authLogin } = useAuth();
  const classes = useStyles();
  const [forgotPasswordDialogOpen, setForgotPasswordDialogOpen] = useState();

  const openSendForgotPasswordDialog = (e) => {
    e.preventDefault();
    setForgotPasswordDialogOpen(true);
  };

  return (
    <Level2BoxContainer>
      <Level2BoxHeading color="primary">
        <Trans>Sign in</Trans>
      </Level2BoxHeading>

      <Formik
        initialValues={{
          username: "",
          password: "",
        }}
        validationSchema={loginSchema(t)}
        onSubmit={(values, { setSubmitting, setErrors, setValues }) => {
          // Trim spaces from username:
          setValues({ ...values, username: values.username.trim() });
          authLogin(values.username.trim(), values.password)
            .then((result) => {
              handleLoginSuccess(result);
            })
            .catch(() => {});
        }}
      >
        {({ submitForm, isValid, values }) => {
          return (
            <Form className={classes.form}>
              <Field
                id="login-email-address"
                component={FormikTextField}
                label={t("Email address")}
                name="username"
                variant="outlined"
                autoFocus
                fullWidth
              />
              <Field
                id="login-password"
                component={FormikTextField}
                type="password"
                label={t("Password")}
                name="password"
                variant="outlined"
                fullWidth
              />
              <FormHelperText error={!!loginError}>
                {loginError}
              </FormHelperText>

              <p className={classes.subText}>
                <Trans>Forgot your password?</Trans>{" "}
                <Link onClick={openSendForgotPasswordDialog}>
                  <Trans>Click here</Trans>
                </Link>
              </p>

              <BoxActions>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleGoBack}
                  className={classes.button}
                >
                  <Trans>Back</Trans>
                </Button>
                <LoadingButton
                  variant="primary"
                  isLoading={isAuthenticating}
                  onClick={submitForm}
                  disabled={!isValid}
                  className={classes.button}
                >
                  <Trans>Sign in</Trans>
                </LoadingButton>
              </BoxActions>
              {forgotPasswordDialogOpen && (
                <ForgotPasswordDialog
                  email={values.email}
                  onClose={() => setForgotPasswordDialogOpen(false)}
                />
              )}
            </Form>
          );
        }}
      </Formik>
    </Level2BoxContainer>
  );
};

const loginSchema = (t) => () => {
  return Yup.object().shape({
    password: Yup.string()
      .min(3, t("That's too short!"))
      .required(t("This is required!")),
  });
};

export default LoginExistingUser;
